module.exports = __webpack_public_path__ + "img/kitimg6.059c8f3a.jpg";